import { RestaurantMap, RestaurantTable } from "@/shared/utils/interfaces";
import MapEdit from "./MapEdit";
import MapTables from "./MapTables";
import MapsFooter from "./MapsFooter";

export interface MapsMenuProps {
  tables: RestaurantTable[];
  setFirstAsDefault?: boolean;
  value?: number;
  onChange?: (map: RestaurantMap) => void;
  editable?: boolean;
  table?: number;
  setTable?: (tableId: number) => void;
  maps?: RestaurantMap[];
  tablePropertyName?: string;
  showMapChose?: boolean;
  showMapName?: boolean;
}

const MapsMenu = ({
  table,
  setTable,
  showMapChose = true,
  editable = false,
  tables = [],
  value,
  onChange,
  maps = undefined,
  showMapName = false,
  tablePropertyName = "item_id",
}: MapsMenuProps) => {
  return (
    <>
      {showMapChose && (
        <MapEdit
          customMaps={maps}
          editable={editable}
          value={value}
          onChange={onChange}
        />
      )}
      <MapTables
        showMapName={showMapName}
        tablePropertyName={tablePropertyName}
        table={table}
        setTable={setTable}
        editable={editable}
        tables={tables}
      />
      {editable && <MapsFooter />}
    </>
  );
};

export default MapsMenu;
